import { Compare } from "@/components/Compare";
import { SmartImage } from "@/components/SmartImage";
import { cn } from "@/lib/utils";

/** Before/after for signed app media. Thin wrapper over the fast <Compare> (CSS-variable scrubbing, pointer capture,
 *  hover-scrub on desktop) with SmartImage layers so expired links recover. Falls back to a single image when there is no "after". */
export const ImageCompare = ({ beforeUrl, afterUrl, beforeFallbacks, afterFallbacks, beforeLabel = "Før", afterLabel = "Etter", afterBadge = null, className, aspect = "4 / 3", fit = "contain", initial = 50, testid = "image-compare" }) => {
  if (!afterUrl) {
    return (
      <div className={cn("image-canvas relative overflow-hidden rounded-[12px]", className)} style={{ aspectRatio: aspect }}>
        {beforeUrl && <SmartImage src={beforeUrl} fallbacks={beforeFallbacks} alt={beforeLabel} imgClassName={fit === "cover" ? "object-cover" : "object-contain"} />}
        <span className="absolute left-2.5 top-2.5 rounded-[8px] bg-black/60 text-white px-2 py-0.5 text-[11.5px] font-medium backdrop-blur">{beforeLabel}</span>
      </div>
    );
  }
  return (
    <Compare before={beforeUrl} after={afterUrl} beforeFallbacks={beforeFallbacks} afterFallbacks={afterFallbacks} beforeLabel={beforeLabel} afterLabel={afterBadge ? null : afterLabel} smart fit={fit} aspect={aspect} initial={initial}
      className={cn("image-canvas", className)} testid={testid}>
      {afterBadge && <span className="absolute top-3 right-3 flex items-center gap-1.5 pointer-events-none">{afterBadge}<span className="rounded-[8px] bg-white/90 text-[hsl(var(--ink))] px-2.5 py-1 text-[12px] font-medium backdrop-blur">{afterLabel}</span></span>}
    </Compare>
  );
};
